import axios from 'axios';
import { getAccessToken } from '@/assets/js/auth';

export const getResourceUsage = async (year, month, teamId) => {
  if (teamId.length < 10) {
      teamId = localStorage.getItem('current_team_id');
  }
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.get(`/api/usage/report?team_id=${teamId}&year=${year}&month=${month}&chartified=true`, settings);
}
